/* ============================================================
   DRUCKPUNKT — Theme JS
   Haptik, Tastendruck, Warenkorb-Schublade, Reveal.
   ============================================================ */
(function () {
  'use strict';

  var T = (window.theme = window.theme || {});
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Geld formatieren ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '{{amount}} €';
    function num(value, decimals, thousand, decimal) {
      value = (value / 100).toFixed(decimals);
      var parts = value.split('.');
      var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return int + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2, '.', ',');
      }
    });
  }
  T.money = money;

  /* ---------- Haptik ---------- */
  var Haptics = {
    on: localStorage.getItem('dp:haptics') !== 'off',
    supported: 'vibrate' in navigator,
    tap: function (ms) {
      if (!this.on || !this.supported || reduce) return;
      try { navigator.vibrate(ms || 8); } catch (e) {}
    },
    ok: function () {
      if (!this.on || !this.supported || reduce) return;
      try { navigator.vibrate([9, 40, 16]); } catch (e) {}
    },
    set: function (state) {
      this.on = state;
      localStorage.setItem('dp:haptics', state ? 'on' : 'off');
      if (state) this.tap(14);
    }
  };
  T.haptics = Haptics;

  document.querySelectorAll('[data-haptic-toggle]').forEach(function (btn) {
    btn.setAttribute('aria-pressed', String(Haptics.on));
    btn.addEventListener('click', function () {
      Haptics.set(btn.getAttribute('aria-pressed') !== 'true');
      btn.setAttribute('aria-pressed', String(Haptics.on));
    });
  });

  /* ---------- Tastendruck: Einsinken + Ripple + Vibration ---------- */
  function pressDown(e) {
    var key = e.target.closest('.key');
    if (!key || key.hasAttribute('disabled')) return;
    key.classList.add('is-pressed');
    Haptics.tap(8);
    if (reduce) return;
    var r = key.getBoundingClientRect();
    var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
    var y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
    var size = Math.max(r.width, r.height) * 2.4;
    var ink = document.createElement('span');
    ink.className = 'ripple';
    ink.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px';
    if (getComputedStyle(key).position === 'static') key.style.position = 'relative';
    key.appendChild(ink);
    setTimeout(function () { ink.remove(); }, 560);
  }
  function pressUp() {
    document.querySelectorAll('.key.is-pressed').forEach(function (k) { k.classList.remove('is-pressed'); });
  }
  document.addEventListener('pointerdown', pressDown, { passive: true });
  document.addEventListener('pointerup', pressUp);
  document.addEventListener('pointercancel', pressUp);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var k = document.activeElement && document.activeElement.closest('.key');
    if (k) { k.classList.add('is-pressed'); Haptics.tap(8); }
  });
  document.addEventListener('keyup', pressUp);

  /* ---------- Sticky Header ---------- */
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var stick = function () { hdr.classList.toggle('is-stuck', window.scrollY > 12); };
    stick();
    window.addEventListener('scroll', stick, { passive: true });
  }

  /* ---------- Scroll-Reveal ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.transitionDelay = (en.target.dataset.delay || 0) + 'ms';
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    document.querySelectorAll('.rise').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rise').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Panels (Schublade, Menü) ---------- */
  function panel(el, scrim) {
    var last = null;
    return {
      open: function () {
        last = document.activeElement;
        el.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
        el.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        Haptics.tap(11);
        var f = el.querySelector('button, a, input');
        if (f) setTimeout(function () { f.focus(); }, 260);
      },
      close: function () {
        el.classList.remove('is-open');
        if (scrim) scrim.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (last) last.focus();
      },
      isOpen: function () { return el.classList.contains('is-open'); }
    };
  }

  var scrim = document.querySelector('[data-scrim]');
  var drawerEl = document.querySelector('[data-drawer]');
  var sheetEl = document.querySelector('[data-msheet]');
  var drawer = drawerEl ? panel(drawerEl, scrim) : null;
  var sheet = sheetEl ? panel(sheetEl, scrim) : null;
  T.drawer = drawer;

  function closeAll() { if (drawer) drawer.close(); if (sheet) sheet.close(); }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.querySelectorAll('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); if (drawer) { renderCart(); drawer.open(); } });
  });
  document.querySelectorAll('[data-open-menu]').forEach(function (b) {
    b.addEventListener('click', function () { if (sheet) sheet.open(); });
  });
  document.querySelectorAll('[data-close-panel]').forEach(function (b) {
    b.addEventListener('click', closeAll);
  });

  /* ---------- Warenkorb ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }

  function itemHTML(item, i) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="74" height="74">'
      : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="li__v">' + item.variant_title + '</div>' : '';
    return '' +
      '<div class="li" data-line="' + (i + 1) + '">' +
        '<div class="li__img">' + img + '</div>' +
        '<div>' +
          '<a class="li__t" href="' + item.url + '">' + item.product_title + '</a>' + variant +
          '<div class="li__f">' +
            '<div class="qty">' +
              '<button type="button" data-step="-1" aria-label="Menge verringern">&minus;</button>' +
              '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-line-qty aria-label="Menge">' +
              '<button type="button" data-step="1" aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<span class="price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="li__rm" data-remove>Entfernen</button>' +
        '</div>' +
      '</div>';
  }

  function paint(cart) {
    setCount(cart.item_count);
    var body = document.querySelector('[data-drawer-body]');
    var foot = document.querySelector('[data-drawer-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML =
        '<div class="empty">' +
          '<div class="empty__i"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12h11.2l2.2-8H6.2"/></svg></div>' +
          '<div><strong>Noch nichts drin</strong><p class="muted" style="font-size:.92rem">Stöbere durch die Kategorien und tippe auf das Plus, um etwas hinzuzufügen.</p></div>' +
          '<a href="/collections/all" class="key btn btn--fill">Produkte ansehen</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(itemHTML).join('');
    if (foot) {
      foot.hidden = false;
      var total = foot.querySelector('[data-cart-total]');
      if (total) total.textContent = money(cart.total_price);
    }
  }

  function renderCart() {
    return fetch(T.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }

  function change(line, quantity) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(paint);
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    var rm = e.target.closest('[data-remove]');
    var row = e.target.closest('[data-line]');
    if (!row) return;
    var line = parseInt(row.dataset.line, 10);
    if (rm) { Haptics.tap(12); change(line, 0); return; }
    if (step) {
      var input = row.querySelector('[data-line-qty]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.step, 10));
      input.value = next;
      Haptics.tap(7);
      change(line, next);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var row = input.closest('[data-line]');
    change(parseInt(row.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- In den Warenkorb (AJAX) ---------- */
  T.addToCart = function (form, btn) {
    var label = btn ? btn.querySelector('[data-label]') : null;
    var original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Wird hinzugefügt …';

    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
        Haptics.ok();
        if (label) label.textContent = 'Hinzugefügt';
        return renderCart().then(function () {
          if (drawer) drawer.open();
          setTimeout(function () { if (label) label.textContent = original; if (btn) btn.disabled = false; }, 1400);
        });
      })
      .catch(function (err) {
        if (label) label.textContent = err.message.slice(0, 60);
        setTimeout(function () { if (label) label.textContent = original; if (btn) btn.disabled = false; }, 2600);
      });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    T.addToCart(form, form.querySelector('[data-add-btn]'));
  });

  /* ---------- Schnell-Hinzufügen aus dem Raster ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    var id = q.dataset.quickAdd;
    if (!id) return;
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    q.disabled = true;
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function () { Haptics.ok(); return renderCart(); })
      .then(function () { if (drawer) drawer.open(); })
      .finally(function () { q.disabled = false; });
  });

  /* ---------- Mengensteuerung auf der Produktseite ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
        input.value = v;
        Haptics.tap(7);
      });
    });
  });

  /* ---------- Variantenwahl ---------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = addBtn ? addBtn.querySelector('[data-label]') : null;

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
        var on = g.querySelector('[aria-checked="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function update() {
      var chosen = selected();
      var match = data.find(function (v) {
        return chosen.every(function (val, i) { return !val || v.options[i] === val; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '<span class="price">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<del class="price">' + money(match.compare_at_price) + '</del>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      var img = root.querySelector('[data-gallery-main] img');
      if (img && match.featured_image) img.src = match.featured_image;
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }

    root.querySelectorAll('[data-option-group] .chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.closest('[data-option-group]').querySelectorAll('.chip').forEach(function (c) {
          c.setAttribute('aria-checked', 'false');
        });
        chip.setAttribute('aria-checked', 'true');
        update();
      });
    });
  });

  /* ---------- Galerie ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.dataset.thumb; main.srcset = ''; }
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Sortierung ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Newsletter-Bestätigung ---------- */
  if (new URLSearchParams(window.location.search).has('customer_posted')) {
    var ok = document.querySelector('[data-nl-ok]');
    if (ok) { ok.hidden = false; Haptics.ok(); }
  }

  setCount(T.cartCount || 0);
})();
